module.exports = __webpack_public_path__ + "static/media/logomin.785458e8.png";